import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
  })
export class IpSharingUrlService {

    private url = '';


    getUrl(){
        return this.url;
    }

    setUrl(url: string){
        this.url = url;
    }
}

  